import { cn } from '@lashpic/ui/admin';
import type { LucideIcon } from 'lucide-react';
import { AlertTriangle, LayoutDashboard, MessageCircle, MoreHorizontal, Rocket } from 'lucide-react';
import { NavLink } from 'react-router-dom';

interface MobileTab {
  path: string;
  label: string;
  icon: LucideIcon;
}

/** docs/specs/superadmin.md §3.3 모바일 하단 탭 5칸 */
const MOBILE_TABS: readonly MobileTab[] = [
  { path: '/overview/dashboard', label: '대시보드', icon: LayoutDashboard },
  { path: '/studio/incidents', label: '인시던트', icon: AlertTriangle },
  { path: '/studio/experiments', label: '롤아웃', icon: Rocket },
  { path: '/people/feedback', label: '피드백', icon: MessageCircle },
  { path: '/more', label: '더보기', icon: MoreHorizontal },
];

export function MobileTabBar() {
  return (
    <nav
      className="hairline-t sticky bottom-0 left-0 right-0 z-30 flex h-[64px] shrink-0 items-stretch bg-[var(--color-admin-sidebar)] backdrop-blur-2xl saturate-150"
      aria-label="모바일 기본 내비게이션"
    >
      {MOBILE_TABS.map((tab) => {
        const Icon = tab.icon;
        return (
          <NavLink
            key={tab.path}
            to={tab.path}
            className={({ isActive }) =>
              cn(
                'admin-focus-ring flex flex-1 flex-col items-center justify-center gap-1 text-[10px] font-medium transition-colors',
                isActive
                  ? 'text-[var(--color-admin-blue)]'
                  : 'text-[var(--color-admin-text-secondary)]',
              )
            }
          >
            <Icon className="size-5" aria-hidden />
            <span>{tab.label}</span>
          </NavLink>
        );
      })}
    </nav>
  );
}
